/* Surulere Foods — Filter & Sort Persistence
   Saves active filters/sort to sessionStorage so they persist
   across pagination and back-navigation. Shows visible filter chips. */
(function(){
  'use strict';
  var KEY = 'sf_filters';

  function isCollectionPage(){
    return /^\/collections\//.test(window.location.pathname);
  }

  function getParams(){
    return new URLSearchParams(window.location.search);
  }

  function saveFilters(){
    if(!isCollectionPage()) return;
    var path = window.location.pathname;
    var params = getParams().toString();
    if(params){
      sessionStorage.setItem(KEY + '_' + path, params);
    }
  }

  function restoreFilters(){
    if(!isCollectionPage()) return;
    var params = getParams();
    if(params.toString()) return;

    var path = window.location.pathname;
    var saved = sessionStorage.getItem(KEY + '_' + path);
    if(saved){
      window.history.replaceState(null, '', path + '?' + saved);
    }
  }

  function renderChips(){
    var container = document.getElementById('sfFilterChips');
    if(!container) return;

    var params = getParams();
    var chips = [];
    params.forEach(function(value, key){
      if(key === 'page' || key === 'q') return;
      var label = key.replace(/^filter\.v\.option\./, '').replace(/^filter\./, '').replace(/_/g, ' ');
      chips.push({ key: key, value: value, label: label + ': ' + value });
    });

    if(chips.length === 0){ container.style.display = 'none'; return; }

    container.style.display = 'flex';
    container.innerHTML = '';
    chips.forEach(function(c){
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'sf-fchip';
      chip.innerHTML = c.label + ' <svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;"><path d="M18 6L6 18M6 6l12 12"/></svg>';
      chip.addEventListener('click', function(){
        var p = getParams();
        p.delete(c.key);
        var newUrl = window.location.pathname;
        if(p.toString()) newUrl += '?' + p.toString();
        window.location.href = newUrl;
      });
      container.appendChild(chip);
    });

    if(chips.length > 1){
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'sf-fchip sf-fchip--clear';
      clear.textContent = 'Clear all';
      clear.addEventListener('click', function(){
        sessionStorage.removeItem(KEY + '_' + window.location.pathname);
        window.location.href = window.location.pathname;
      });
      container.appendChild(clear);
    }
  }

  restoreFilters();
  saveFilters();
  renderChips();
})();
